import { trpc } from "../trpc";

interface Input {
  folderId: string;
}

export function useSetPinnedCanvas({ folderId }: Input) {
  const utils = trpc.useUtils();

  const mutation = trpc.folder.setPinnedCanvas.useMutation({
    onMutate: async ({ pinnedCanvasId }) => {
      await utils.folder.getById.cancel({ folderId });

      // Store previous data for rollback.
      const previousData = utils.folder.getById.getData({ folderId });

      utils.folder.getById.setData({ folderId }, (previousFolder) => {
        if (!previousFolder) {
          return previousFolder;
        }
        return { ...previousFolder, pinnedCanvasId };
      });

      return { previousData };
    },
    onError: (_error, _variables, context) => {
      if (context?.previousData) {
        utils.folder.getById.setData({ folderId }, context.previousData);
      }
    },
    onSettled: async () => {
      await utils.folder.getById.invalidate({ folderId });
    },
  });

  return {
    setPinnedCanvasAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
  };
}
